var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { staticClass: "mainPage", attrs: { id: "mainPageStandardImage" } },
    [
      _c(
        "v-content",
        [
          _c("ValidationObserver", {
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var handleSubmit = ref.handleSubmit
                    return [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          attrs: {
                            onSubmit: "return false;",
                            autocomplete: "on"
                          },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return handleSubmit(_vm.submit)
                            }
                          }
                        },
                        [
                          _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "welcome-container lili-flex justify-center"
                              },
                              [
                                _vm.isTopContent
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "welcome-content lili-container lili-flex column align-center"
                                      },
                                      [
                                        _c("TopContent", {
                                          attrs: { isGoBack: true },
                                          on: {
                                            callSubmit: function($event) {
                                              return handleSubmit(_vm.submit)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "lili-divider"
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "dataSection" }, [
                              _c(
                                "div",
                                { staticClass: "dataContent" },
                                [
                                  _c(
                                    "v-container",
                                    [
                                      _c(
                                        "v-layout",
                                        { attrs: { "justify-center": "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              attrs: {
                                                xs8: "",
                                                "align-center": ""
                                              }
                                            },
                                            [
                                              !_vm.noTitle
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "progress-bubble-text"
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                      " +
                                                          _vm._s(
                                                            _vm.progressText
                                                          ) +
                                                          "\n                    "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm._t("data")
                                ],
                                2
                              )
                            ])
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.$store.state.timeout
                        ? _c("div", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "user-msg-container lili-flex align-center justify-center"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "user-msg-conent lili-flex column align-center"
                                  },
                                  [
                                    _c("h2", [
                                      _vm._v(
                                        _vm._s(_vm.$t("template.timeoutTitle"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(_vm.$t("template.timeoutBody"))
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          depressed: "",
                                          color: "#35d6ed",
                                          id: "restartTimeout"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.timeoutRestart(false)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("template.timeoutButton")
                                          ) + "\n          "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ]
                  }
                }
              ],
              null,
              true
            )
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ebc2dc48", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebc2dc48","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/base-template.vue
// module id = null
// module chunks = 